import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import PropTypes from "prop-types";

/**
 * Componente reutilizável para alertas customizável pré-configurado para mensagens de erro
 */
function ErrorSwal({ title = "Oops!", text = null, html = null, ...props }) {
  const MySwal = withReactContent(Swal);

  return MySwal.fire({
    title: title,
    text: text,
    html: html,
    icon: "error",
    confirmButtonColor: "#50a5f1",
    ...props,
  });
}

ErrorSwal.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  html: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

export default ErrorSwal;
